// extracted by mini-css-extract-plugin
export default {"lobbyHeader":"lobby_lobbyHeader__ZPgoZ"};